<template lang="pug">
  .cashback-banner-container
    .cashback-banner-item(
      v-for="(item, index) in list"
      @click="handleBannerClick(item, index)"
      v-platform-expose="{ handler: handleBannerExpose, data: { item, index } }"
    )
      img.banner-img(:src="item.imgUrl" alt="")
</template>

<script>
import HighlightText from '@/components/highlight-text';
import SPM from '../../common/spm';

export default {
  name: 'CashbackBanner',
  components: {
    HighlightText,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    // banner点击
    handleBannerClick(item, index) {
      this.$emit('bannerClick', item, index);
      // 投放banner点击埋点
      SPM.clickButton({
        buttonName: 'Welfare_onlineretailers_banner',
        businessInfo: {
          banner_actId: item.actId,
          banner_channel: item.channel,
          rankNum: index + 1,
          ...item,
        },
      });
    },
    // 投放banner曝光埋点
    handleBannerExpose(_entry, data) {
      const { item, index = 0 } = data || {};
      if (this.list && this.list.length > 0) {
        SPM.moduleExpose({
          moduleId: 'Welfare_onlineretailers_banner',
          contentId: 'Welfare_onlineretailers_banner',
          businessInfo: {
            banner_actId: item.actId,
            banner_channel: item.channel,
            rankNum: index + 1,
            ...item,
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.cashback-banner-container {
  display: flex;
  justify-content: space-between;
  width: 100%;

  .cashback-banner-item {
    width: 1.59rem;

    .banner-img {
      width: 100%;
      vertical-align: bottom;
    }
  }
}
</style>
